import './index.css';
import './utils/smoothScroll';
import 'normalize.css';
import 'react-image-lightbox/style.css';
import 'react-notifications/lib/notifications.css';
import 'react-placeholder/lib/reactPlaceholder.css';
import 'react-simple-dropdown/styles/Dropdown.css';

import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import * as React from 'react';
import { ApolloProvider } from 'react-apollo';
import * as ReactDOM from 'react-dom';
import * as ga from 'react-ga';
import { Provider } from 'react-redux';

import { client } from './apollo';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import store from './store';

// import 'animate.css';
// new Wow().init();

const history = createBrowserHistory();

const code = 'UA-144979377-1';

ga.initialize(code, {
  debug: false
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>
  </ApolloProvider>,
  document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx